{
  "version": 1,
  "asset_id": "8d812d96-1234-411a-8c9b-cc5060cc50e8",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8d812d96-1234-411a-8c9b-cc5060cc50e8/bypass-revision-oversized-pouch-en.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8d812d96-1234-411a-8c9b-cc5060cc50e8/bypass-revision-oversized-pouch-en.webp",
  "original_filename": "bypass-revision-oversized-pouch-en.webp",
  "size": 170118,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:21Z"
}
